/**
 *@ngdoc directive
 *@name cbl.finanza.mf.directive:finanzaGestioneRichiesta
 *@restrict E
 *@scope
 *@description Componente utilizzato per inserire le richieste d'ordine e per visualizzare il riepilogo dei documenti
 *@param {String} gestioneOrdineState - Nome dello stato per gestire un ordine
 *@param {String} saldoDossierState - Nome dello stato del saldo dossier
 */
(function () {
  'use strict';
  var GestioneRichiestaCtrl = function (
    $q,
    $scope,
    $http,
    $state,
    $stateParams,
    $window,
    $location,
    $uibModal,
    CONSTANTS,
    messaggiFctr,
    labelSrvc,
    messaggiSrvc,
    userSrvc,
    brioSrvc,
    deskSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.messaggiFctr = messaggiFctr;
    this.messaggiSrvc = messaggiSrvc;
    this.userSrvc = userSrvc;
    this.brioSrvc = brioSrvc;
    this.deskSrvc = deskSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    this.spinner = {
      listaOrdini: false,
      avanzamento: false
    };
    this.ordiniTableData = [];
    this.richiesta = {};
    this.messaggiFctr.chiudiLoaderBrio();
    this.anagraficaFea = {};
    this.isBloccoCutOff = false;
    var self = this;

    //
    //		---------------------------- REST PROMISES ----------------------------
    //

    /**
     * @ngdoc method
     * @name promiseCustomerData
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua la chiamata per ricevere il customerdata
     * @return {Promise} - Ritorna una promise contenente il customerdata
     */
    this.promiseCustomerData = function () {
      return self.$http({
        method: 'GET',
        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
        params: {
          rapporto: self.$stateParams.finCodiceRapporto
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseDatiTabellaRichieste
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per ricevere la lista delle richieste associate ad una raccomandazione
     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista delle richieste
     */
    this.promiseDatiTabellaOrdini = function () {
      self.spinner.listaOrdini = true;
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          self.$stateParams.finIdRichiesta +
          '/ordini'
      });
    };

    /**
     * @ngdoc method
     * @name promiseDettaglioRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per ricevere il dettaglio di una richiesta
     * @return {Promise} - Ritorna una promise contenente i dati del dettaglio di una richiesta
     */
    this.promiseDettaglioRichiesta = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          'richiesta/' +
          self.$stateParams.finIdRichiesta
      });
    };

    /**
     * @ngdoc method
     * @name promiseConsolidaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per consolidare una richiesta
     * @return {Promise} - Ritorna una promise contenente il risultato del consolida richiesta
     */
    this.promiseConsolidaRichiesta = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          self.$stateParams.finIdRichiesta +
          '/consolida'
      });
    };

    /**
     * @ngdoc method
     * @name promiseAccettaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per accettare una richiesta
     * @return {Promise} - Ritorna una promise contenente il risultato dell'accetta richiesta
     */
    this.promiseAccettaRichiesta = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          self.$stateParams.finIdRichiesta +
          '/accetta'
      });
    };

    /**
     * @ngdoc method
     * @name promiseRevisionaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per revisionare una richiesta
     * @return {Promise} - Ritorna una promise contenente il risultato della revisione richiesta
     */
    this.promiseRevisionaRichiesta = function (nota) {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          'revisione/' +
          self.$stateParams.finIdRichiesta,
        data: { nota: nota }
      });
    };

    /**
     * @ngdoc method
     * @name promiseRifiutaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per rifiutare una richiesta
     * @return {Promise} - Ritorna una promise contenente il risultato del rifiuta richiesta
     */
    this.promiseRifiutaRichiesta = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          'rifiuta/' +
          self.$stateParams.finIdRichiesta
      });
    };

    /**
     * @ngdoc method
     * @name promiseAccettaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per accettare una richiesta
     * @return {Promise} - Ritorna una promise contenente il risultato dell'accetta richiesta
     */
    this.promiseTerminaRichiesta = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          'termina/' +
          self.$stateParams.finIdRichiesta
      });
    };

    /**
     * @ngdoc method
     * @name promiseIniziaRevisioneRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per iniziare la revisione di una richiesta
     * @return {Promise} - Ritorna una promise contenente il risultato dell'avvio della revisione richiesta
     */
    this.promiseIniziaRevisioneRichiesta = function () {
      return self.$http({
        method: 'PUT',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RICHIESTA +
          'iniziaRevisione/' +
          self.$stateParams.finIdRichiesta
      });
    };

    /**
     * @ngdoc method
     * @name promiseDati
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Effettua una chiamata http per ricevere il dettaglio dell'ndg
     * @return {Promise} - Ritorna una promise contenente l'anagrafica
     */
    this.promiseAnagrafica = function () {
      return self.$http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA + 'Intestatario',
        params: {
          ndg: self.$stateParams.ndg
        }
      });
    };
    this.promiseBloccoCutOff = function(finIdRichiesta) {
      return $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CUT_OFF+ '/'+ 
        finIdRichiesta,
        params: {}
      });
  };
    //
    //		-------------------------- INIT LABEL TABELLE -------------------------
    //

    /**
     * @ngdoc method
     * @name initLabelTabellaOrdini
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Crea le label e la struttura della tabella degli ordini
     */
    this.initLabelTabellaOrdini = function () {
      self.ordiniTableLabel = [
        {
          name: $scope.msg('lista.ordini.descrizione'),
          field: 'DescrizioneStrumento',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.ordini.intestatario'),
          field: 'Intestazione',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.proposte.acq.ven'),
          field: 'tipo.segno',
          width: '*',
          enableFiltering: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.ordini.a\') === row.entity.segno">{{grid.appScope.msg(\'lista.ordini.acq\')}}</div>' +
            '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.ordini.d\') === row.entity.segno">{{grid.appScope.msg(\'lista.ordini.ven\')}}</div>' +
            '<div class="ui-grid-cell-contents" ng-if="grid.appScope.msg(\'lista.ordini.s\') === row.entity.segno">{{grid.appScope.msg(\'lista.ordini.swi\')}}</div>' +
            '<div class="ui-grid-cell-contents" ng-if="\'P\' === row.entity.segno">{{grid.appScope.msg(\'lista.ordini.piano\')}}</div>'
        },
        {
          name: $scope.msg('lista.ordini.qta'),
          field: 'quantita',
          width: '12%',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.ordini.ctv.teorico'),
          field: 'ctvPrevisto',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.ordini.tipo.ordine'),
          field: 'codiceOrdine',
          width: '12%',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.ordini.check'),
          field: 'check',
          width: '*',
          enableFiltering: false,
          cellClass: 'center',
          cellTemplate:
            '<i class="fa fa-circle fa-2x finIMargin" ng-class="{finIGreen : row.entity.profiloAppropriatezza >= row.entity.rischioComplessita, finIOrange: row.entity.profiloAppropriatezza < row.entity.rischioComplessita}" aria-hidden="true"></i>'
        },
        {
          name: 'Stato', /**Da riempire con  label */
          field: 'descrizioneStatoOrdine',
          width: '*',
          enableFiltering: false,
          cellClass: 'center',
        },{
          name:'Numero ordine',/**Da riempire con  label */
          field: 'numeroOrdine',
          width: '*',
          enableFiltering: false,
          cellClass: 'center',
        },
      ];
      if (
        self.$stateParams.finIdRaccomandazione ||
        self.$state.current.name.indexOf('visualizza') > -1
      ) {
        self.ordiniTableLabel.push({
          name: $scope.msg('lista.ordini.azione'),
          field: 'azione',
          width: 60,
          enableFiltering: false,
          cellTemplate:
            '<i class="fa fa-search finIPointer finIMargin fa-2x" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaOrdine({ordine: row.entity})"></i>'
        });
      } else {
        self.ordiniTableLabel.push({
          name: $scope.msg('lista.ordini.azione'),
          field: 'azione',
          width: 60,
          enableFiltering: false,
          cellTemplate:
            '<i class="fa fa-pencil finIPointer finIMargin fa-2x" aria-hidden="true" uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-click="grid.appScope.gestioneOrdine({ordine: row.entity})"></i>'
        });
      }
    };

    /**
     * @ngdoc method
     * @name initData
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Esegue il caricamento dei dati per la pagina
     */
    this.initData = function () {
      $q.all({
        label: labelSrvc.labelsPronte,
        ordini: self.promiseDatiTabellaOrdini(),
        richiesta: self.promiseDettaglioRichiesta()
      })
        .then(
          function (response) {
            if (
              self.messaggiFctr.processaResponse(response.ordini) ||
              self.messaggiFctr.processaResponse(response.richiesta)
            ) {
              self.ordiniTableData = [];
              return;
            }
            self.richiesta = response.richiesta.data.result;
            self.getCustomerDossier();
            self.checkStatoPraticaInValutazione();
            self.initLabelTabellaOrdini();
            self.ordiniTableData = response.ordini.data.result;
            self.setAnagraficaFea();

            if (
              self.richiesta &&
              self.richiesta.stato ===
                CONSTANTS.STATO_RACCOMANDAZIONE.DA_REVISIONARE
            ) {
              self.avviaRevisionePratica();
              return;
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.ordini);
            self.messaggiFctr.processaResponse(reason.richiesta);
            self.messaggiFctr.processaResponse(reason.customerDossier);
            self.ordiniTableData = [];
          }
        )
        .finally(function () {
          self.initTabListMacro();
          self.spinner.listaOrdini = false;
        });
    };
    this.initBloccoCutOff = function(finIdRichiesta)
    {
      self.promiseBloccoCutOff(finIdRichiesta)
      .then(function(response){
        if(self.modalita &&
          self.modalita.stato !== CONSTANTS.MODALITA.VISUALIZZA ){
              //BLOCCO CUT-OFF IL PULSANTE ACCETTA VIENE DISABILITATO NEL CASO IN CUI RITORNI UNA LISTA DI ERRORI
              //O SE RESULT === FALSE
              if(self.messaggiFctr.processaResponse(response) || response.data.result === false ){
              self.isBloccoCutOff = true;
              self.spinner.avanzamento = false;
              }
        }
      });
    }
    //
    //		--------------------------- INIT CONTROLLER ---------------------------
    //

    //		Se non ho il codiceRapporto perché vengo da Brio lo prendo, lo metto nello $stateParams e faccio un refresh
    if (!self.$stateParams.finCodiceRapporto) {
      self.promiseDettaglioRichiesta().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          if (response.data.result) {
            self.$stateParams.finCodiceRapporto =
              response.data.result.codiceDossierTitoli;
            self.$state.go(self.$state.current.name, self.$stateParams, {
              reload: true
            });
          }
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      );
    } else {
      // Normale funzionamento
      self.initData();
      //self.initBloccoCutOff(self.$stateParams.finIdRichiesta);
    }
    //
    //		---------------------------- HELPER METHOD ----------------------------
    //
    /**
     * @ngdoc method
     * @name getCustomerDossier
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Dicide quale servizio per il customer dossier richiamare
     */
    this.getCustomerDossier = function () {
      // Chiamo il getDossier per inserire le info nel customerdata
      self.promiseCustomerData().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.posizione = {};
            return;
          }
          self.posizione = response.data;
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    /**
     * @ngdoc method
     * @name checkStatoPraticaInValutazione
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     *@description Se siamo in INCORSO, PRESENTATA o VALUTAZIONE e
     * la pratica è in uno stato diverso da PRESENTATA
     * effettuo il redirect allo stato di visualizzazione
     */
    this.checkStatoPraticaInValutazione = function () {
      var statiRichiestaModificabile = [
        CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO,
        CONSTANTS.STATO_RACCOMANDAZIONE.PRESENTATA,
        CONSTANTS.STATO_RACCOMANDAZIONE.CONSOLIDATA,
        CONSTANTS.STATO_RACCOMANDAZIONE.DA_REVISIONARE
      ];
      //			Se lo stato della raccomandazione non è compreso tra quelli soprastanti
      //			e la modalità è valutazione vado in modalità visualizza
      if (
        statiRichiestaModificabile.indexOf(self.richiesta.stato) === -1 &&
        self.modalita === CONSTANTS.MODALITA.MODIFICA &&
        self.$stateParams.esterno
      ) {
        self.$state.go(self.visualizzaRichiestaState, self.$stateParams, {
          reload: true
        });
      }
    };

    /**
     * @ngdoc method
     * @name avviaRevisionePratica
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Se la pratica è in stato DA REVISIONARE, lancio la chiamata
     * per portarla in revisione e ricarico
     */
    this.avviaRevisionePratica = function () {
      $q.all({
        revisione: self.promiseIniziaRevisioneRichiesta()
      }).then(function (response) {
        if (self.messaggiFctr.processaResponse(response.revisione)) {
          return;
        }

        // Recupero nuovamente la richiesta aggiornata
        self.initData();
        //self.initBloccoCutOff(self.$stateParams.finIdRichiesta);
      });
    };

    /**
     * @ngdoc method
     * @name getDettaglioRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Recupera la richiesta dal backend
     */
    this.getDettaglioRichiesta = function () {
      self
        .promiseDettaglioRichiesta()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.avanzamento = false;
              return;
            }
            self.richiesta = response.data.result;
            self.changeTabMacro(
              self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]
            );
            self.initBloccoCutOff(self.$stateParams.finIdRichiesta);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.avanzamento = false;
        });
    };

    /**
     * @ngdoc method
     * @name initTabListMacro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Inizializza il giusto step in base allo stato della richiesta
     */
    this.initTabListMacro = function () {
      self.TAB_LIST_MACRO = [
        {
          index: 0,
          url:
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'gestioneRichiesta/partials/inserimentoOrdini.html',
          title: $scope.msg('step.inserimento.richieste.ordine')
        },
        {
          index: 1,
          url:
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'gestioneRichiesta/partials/documentiRiepilogo.html',
          title: $scope.msg('step.documenti.riepilogo')
        }
      ];
      if (
        self.richiesta.stato === CONSTANTS.STATO_RACCOMANDAZIONE.IN_CORSO ||
        self.modalita === CONSTANTS.MODALITA.VISUALIZZA
      ) {
        self.currentTabMacro = self.TAB_LIST_MACRO[0];
      } else {
        self.currentTabMacro = self.TAB_LIST_MACRO[1];
      }
    };

    /**
     * @ngdoc method
     * @name setAnagraficaFea
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Crea l'oggetto anagraficaFea per passarlo al widget della FEA
     */
    this.setAnagraficaFea = function () {
      self.anagraficaFea = {
        idAnagrafica: self.richiesta.intestatario.idAnagrafica,
        ndg: self.richiesta.intestatario.ndg,
        naturaGiuridica: self.richiesta.intestatario.formaCostitutiva
      };
    };

    /**
     * @ngdoc method
     * @name ritornoBackOffice
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Dopo aver ricevuto il dettaglio dell'ndg ritorna al backoffice
     */
    this.ritornoBackOffice = function () {
      self.promiseAnagrafica().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          if (
            response.data &&
            response.data.result &&
            response.data.result.length
          ) {
            switch (self.brioSrvc.brioVersion) {
              case 'brio2':
              case 'brio3':
                self.$stateParams.idAnagrafica =
                  response.data.result[0].idAnagrafica;
                self.$state.go('schedaCliente', self.$stateParams);
                break;
              case 'brio-xc':
                var parametri = [
                  //		    				{
                  //		    					chiave: 'idAnagrafica',
                  //		    					valore: response.data.result[0].idAnagrafica
                  //		    				}
                  {
                    chiave: 'ndg',
                    valore: self.$stateParams.ndg
                  }
                ];
                self.brioSrvc.goTo(
                  'scrivaniautente',
                  'home.schedacliente',
                  parametri
                );
                break;
            }
          }
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    /**
     * @ngdoc method
     * @name changeTabMacro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Setta il tab attuale
     * @param {Object} tab - L'oggetto tab che deve essere setatto come attuale
     */
    this.changeTabMacro = function (tab) {
      self.currentTabMacro = tab;
      self.messaggiSrvc.reset();
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Riceve la classe appropriata per la colorazione del macro
     * @param {Number} currentTabIndex - L'indice del tab corrente
     * @return {String} - Il nome delal classe per settare il colore del macro
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-pass';
      }
      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current';
      }
      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Riceve la classe appropriata per la colorazione del macro (soltanto per la modalita visualizza)
     * @param {Number} currentTabIndex - L'indice del tab corrente
     * @return {String} - Il nome della classe per settare il colore del macro
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    //
    //		--------------------------- BUTTONS METHOD ----------------------------
    //

    /**
     * @ngdoc method
     * @name modificaOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Va nello stato di modifica dell'ordine
     * @param {Object} ordine - L'ordine da gestire
     */
    this.gestioneOrdine = function (ordine) {
      self.$stateParams.finIdOrdine = ordine.idOrdine;
      self.$stateParams.finCodiceStrumento = ordine.strumento;
      self.$state.go(self.gestioneOrdineState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name visualizzaOrdine
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Va nello stato di visualizzazione dell'ordine
     * @param {Object} ordine - L'ordine da visualizzare
     */
    this.visualizzaOrdine = function (ordine) {
      self.$stateParams.finIdOrdine = ordine.idOrdine;
      self.$stateParams.finCodiceStrumento = ordine.strumento;
      self.$state.go(self.visualizzaOrdineState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name consolidaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Consolida lo stato della richiesta e va allo step successivo
     */
    this.consolidaRichiesta = function () {
      self.spinner.avanzamento = true;
      self.promiseConsolidaRichiesta().then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.avanzamento = false;
            return;
          }
          if (response.data.result) {
            self.getDettaglioRichiesta();
            /* self.promiseBloccoCutOff(self.$stateParams.finIdRichiesta)
            .then(function(response){
              //BLOCCO CUT-OFF IL PULSANTE ACCETTA VIENE DISABILITATO NEL CASO IN CUI RITORNI UNA LISTA DI ERRORI
              //O SE RESULT === FALSE
              if(self.messaggiFctr.processaResponse(response) || response.data.result === false ){
                self.isBloccoCutOff = true;
                self.spinner.avanzamento = false;
              }
        }) */
          }
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.spinner.avanzamento = false;
        }
      );
    };

    /**
     * @ngdoc method
     * @name accetta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description: Accetta la richiesta e torna allo stato del dettaglio del saldo
     */
    this.accetta = function () {
      self.spinner.avanzamento = true;
      self
        .promiseAccettaRichiesta()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            if (response.data.result) {
                self.ritornoBackOffice();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.avanzamento = false;
        });
    };

    /**
     * @ngdoc method
     * @name revisiona
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description: Manda la richiesta in stato di revisione e torna allo stato del dettaglio del saldo
     */
    this.revisiona = function () {
      var modalController = function ($scope, $modalInstance) {
        $scope.revisionaRichiesta = function () {
          self.spinner.avanzamento = true;
          var nota = $scope.notaRevisione;
          self
            .promiseRevisionaRichiesta(nota)
            .then(
              function (response) {
                if (self.messaggiFctr.processaResponse(response)) {
                  return;
                }
                if (response.data.result) {
                  $modalInstance.close();
                  self.ritornoBackOffice();
                }
              },
              function (reason) {
                self.messaggiFctr.processaResponse(reason);
              }
            )
            .finally(function () {
              self.spinner.avanzamento = false;
            });
        };
      };

      modalController.$inject = ['$scope', '$modalInstance'];

      var modalInstance = this.$uibModal.open({
        animation: true,
        template:
          '<div style="padding: 10px 20px; text-align: center;"><p><b>Inserisci una nota per la revisione</b></p><textarea class="form-control" rows="6" style="width:100%; margin-bottom:15px;" ng-model="notaRevisione"></textarea><button type="button" class="btn btn-primary" ng-click="revisionaRichiesta()">Conferma</button></div>',
        size: 'sm',
        controller: modalController
      });

      modalInstance.result.then(function (confirmResult) {
        if (confirmResult !== true) {
          return;
        }
      });
    };

    /**
     * @ngdoc method
     * @name rifiuta
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description: Rifiuta la richiesta e torna allo stato del dettaglio del saldo
     */
    this.rifiuta = function () {
      self.spinner.avanzamento = true;
      self
        .promiseRifiutaRichiesta()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            if (response.data.result) {
              self.ritornoBackOffice();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.avanzamento = false;
        });
    };

    /**
     * @ngdoc method
     * @name termina
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Termina la gestione della richiesta
     */
    this.termina = function () {
      self.spinner.avanzamento = true;
      self.promiseBloccoCutOff(self.$stateParams.finIdRichiesta)
      .then(function(response) {
        //BLOCCO CUT-OFF IL PULSANTE ACCETTA VIENE DISABILITATO NEL CASO IN CUI RITORNI UNA LISTA DI ERRORI
        //O SE RESULT === FALSE il secondo controllo è preventivo mi aspetto non capiti mai
        if (self.messaggiFctr.processaResponse(response) || response.data.result === false ) {
          self.spinner.avanzamento = false;
          self.isBloccoCutOff = true;
          return;
        }
        self
        .promiseTerminaRichiesta()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            if (response.data.result) {
              if(sessionStorage.getItem('isFromGestioneOrdine')){
                self.$state.go('modificaraccomandazione', self.$stateParams);
              }
              else{
                self.$state.go(self.saldoDossierState, self.$stateParams);
              }
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner.avanzamento = false;
        });
      })
      .finally(function(){
        self.spinner.raccomandazione = false;
      });
    };

    /**
     * @ngdoc method
     * @name avanti
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Procede allo step1 quando siamo in modalita visualizza
     */
    this.avanti = function () {
      self.changeTabMacro(self.TAB_LIST_MACRO[self.currentTabMacro.index + 1]);
    };

    /**
     * @ngdoc method
     * @name indietro
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesta
     * @description Ritorna allo step precedente se siamo in modalita visualizza e allo step1 altrimenti ritorna alla sezione precedente (saldo dossier)
     */
    this.indietro = function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.popEntry();
      }
      if (
        self.modalita === CONSTANTS.MODALITA.VISUALIZZA &&
        self.currentTabMacro.index === 1
      ) {
        self.changeTabMacro(self.TAB_LIST_MACRO[0]);
      } else {
            if (self.$stateParams.esterno) {
              self.ritornoBackOffice();
        }   else if(sessionStorage.getItem('isFromGestioneOrdine') && sessionStorage.getItem('isModifica')){
              /* sessionStorage.removeItem('isFromGestioneOrdine'); */
              sessionStorage.removeItem('isModifica');
              self.$state.go('modificaraccomandazione', self.$stateParams);
        }else if(sessionStorage.getItem('isFromGestioneOrdine') && sessionStorage.getItem('isVisualizza')){
              /* sessionStorage.removeItem('isFromGestioneOrdine'); */
              sessionStorage.removeItem('isVisualizza');
              self.$state.go('visualizzaraccomandazione', self.$stateParams);
        }   
        else {
              self.$state.go(self.saldoDossierState, self.$stateParams);
        }
      }
    };

    if (self.deskSrvc.isDesk) {
      labelSrvc.labelsPronte.then(function () {
        self.deskSrvc.aggiungiEntry(labelSrvc.getLabel('gestione.richiesta'));
      });
    }
  };
  GestioneRichiestaCtrl.$inject = [
    '$q',
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$window',
    '$location',
    '$uibModal',
    'FIN_CONSTANTS',
    'FinMessaggiFctr',
    'FinLabelSrvc',
    'CblMessageSrvc',
    'FinUserSrvc',
    'FinBrioSrvc',
    'FinDeskSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'gestioneRichiesta/gestioneRichiesta.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var GestioneRichiestaComponent = {
    bindings: {
      gestioneOrdineState: '@',
      saldoDossierState: '@',
      visualizzaOrdineState: '@',
      visualizzaRichiestaState: '@',
      modalita: '@'
    },
    controller: GestioneRichiestaCtrl,
    controllerAs: 'gestioneCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finanzaGestioneRichiesta', GestioneRichiestaComponent);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/gestioneRichiesta/gestioneRichiesta.cmpt.js
 ** module id = 19
 ** module chunks = 0 1 2
 **/